import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";
import Vue from "vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {
  faAddressBook,
  faCalendarAlt, faCamera, faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCloudDownloadAlt, faCloudUploadAlt, faCommentAlt, faCommentDots,
  faEnvelope, faExclamationTriangle, faHandPointer,
  faHeadset, faInfoCircle,
  faLink, faMapMarkerAlt,
  faMicrophone,
  faMicrophoneSlash, faPaintBrush,
  faPhone,
  faPlay,
  faPlus,
  faRecordVinyl,
  faSignOutAlt,
  faSms, faStickyNote, faStopwatch,
  faTimes, faTrash,
  faUser,
  faVolumeUp,
  faFilePdf,
  faImage
} from "@fortawesome/free-solid-svg-icons";

library.add(faMicrophone);
library.add(faMicrophoneSlash);
library.add(faVolumeUp);
library.add(faSignOutAlt);
library.add(faHeadset);
library.add(faUser);
library.add(faPlus);
library.add(faTimes);
library.add(faPhone);
library.add(faAddressBook);
library.add(faCalendarAlt);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faRecordVinyl);
library.add(faPlay);
library.add(faCloudDownloadAlt);
library.add(faWhatsapp);
library.add(faSms);
library.add(faLink);
library.add(faEnvelope);
library.add(faInfoCircle);
library.add(faCamera);
library.add(faPaintBrush);
library.add(faHandPointer);
library.add(faCommentDots);
library.add(faCheck);
library.add(faStickyNote);
library.add(faTrash);
library.add(faStopwatch);
library.add(faCommentAlt);
library.add(faMapMarkerAlt);
library.add(faExclamationTriangle);
library.add(faCloudUploadAlt);
library.add(faFilePdf);
library.add(faImage);

Vue.component('fa-icon', FontAwesomeIcon);
